import React, {Component} from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import Status from '../utils/Status';
import ReduxDataTable from '../redux_data_table/ReduxDataTable';
import SiteHealth from '../utils/SiteHealth';

class SiteAlertList extends Component {
  getCssStyleForIcon() {
    return {
      marginTop: '5px',
      display: 'inline-block',
    };
  }

  render() {
    return (
      <div className="table-container">
        <ReduxDataTable
          {...this.props}
          hideDetails={true}
          hideSearch={true}
          notSortable={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9]}
        >
          <thead>
            <tr role="row" className="heading">
              <th width="1%">ID</th>
              <th width="20%">{i18next.t('sites.table_headers.name')}</th>
              <th width="5%">{i18next.t('sites.table_headers.tls_secure')}</th>
              <th width="5%">{i18next.t('sites.table_headers.site_agent_status')}</th>
              <th width="5%">{i18next.t('sites.table_headers.hms_status')}</th>
              <th width="5%">{i18next.t('sites.table_headers.dg2_status')}</th>
              <th width="5%">{i18next.t('sites.table_headers.hardware_status')}</th>
              <th width="5%">{i18next.t('sites.table_headers.hms_version')}</th>
              <th width="15%">{i18next.t('sites.table_headers.last_connected')}</th>
              <th width="15%">{i18next.t('sites.table_headers.monitor')}</th>
            </tr>
          </thead>
          <tbody>
            {this.props.sites.map((site) => {
              return (
                <tr key={site.id} className="odd">
                  <td>{site.id}</td>
                  <td>{site.name}</td>

                  {/* TLS Secured */}
                  <td>
                    <div style={{textAlign: 'center'}}>
                      <span
                        style={this.getCssStyleForIcon(site.secure)}
                      >
                        {site.secure === true ? 'Yes' : 'No'}
                      </span>
                    </div>
                  </td>

                  {/* Site Agent status */}
                  <td className="status-column">
                    <Status online={site.connected}/>
                  </td>

                  {/* HMS Status */}
                  <td className="status-column">
                    <Status online={site.hmsConnected}/>
                  </td>

                  {/* DG2 Status */}
                  <td className="status-column">
                    <Status online={site.dg2Status}/>
                  </td>

                  {/* Hardware Status */}
                  <td>
                    <div style={{textAlign: 'center'}}>
                      <SiteHealth
                        value={site.healthStatus}
                        popoverContent={site.statusMessages}
                      />
                    </div>
                  </td>

                  <td>{site.siteAgentVersion}</td>
                  <td>
                    {site.connected ? i18next.t('sites.online') : site.lastSeen}
                  </td>
                  <td>
                    <button
                      style={{borderRadius: '5px'}}
                      className="btn default-secondary-button"
                      onClick={() => this.props.redirectFunction(site.id)}
                    >
                      {i18next.t('sites.attrs.hapi_details')}
                      <i style={{marginLeft: '10px', color: '#DA002F'}} className="fa fa-external-link"/>&nbsp;
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </ReduxDataTable>
      </div>
    );
  }
}

SiteAlertList.propTypes = {
  sites: PropTypes.array,
  createSiteError: PropTypes.object,
  getSitesError: PropTypes.string,
  destroySiteError: PropTypes.string,
  user: PropTypes.object,
  userSiteAccess: PropTypes.array,
  redirectFunction: PropTypes.func,
};

export default SiteAlertList;
